import { Box, Heading, Paragraph } from 'grommet'
import styled, { css } from 'styled-components'

import { NormalizedWrapper } from '@theme'

export const BlockWrapper = styled(NormalizedWrapper)`
  ${({ theme }) => css`
    margin-top: ${theme.newSpaces.xl5}px;

    ${theme.below.laptop`
      padding: 0 ${theme.newSpaces.sm}px;
    `}

    ${theme.below.mobileXL`
      margin-top: ${theme.newSpaces.xl2}px;
      padding: 0 ${theme.newSpaces.xl}px;
    `}
  `}
`

export const Wrapper = styled(Box)`
  overflow: hidden;
  width: 100%;
`

export const UnderLineWord = styled.span`
  text-decoration: underline;
`

export const Title = styled(Heading)`
  text-transform: capitalize;
  width: 100%;

  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'title', 'title1')}

    color: ${theme.newColors.primary};
    margin-bottom: ${theme.newSpaces.xs}px;

    ${theme.below.mobileXL`
      ${theme.getTypography('mobile', 'title', 'title2')}
    `}
  `}
`

export const SubTitle = styled(Paragraph)`
  max-width: 100%;
  text-align: justify;
  white-space: pre-wrap;

  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'body', 'body2')}

    color: ${theme.newColors.darkGray};

    a {
      ${theme.getTypography('desktop', 'body', 'body2')}
    }

    ${theme.below.mobileXL`
      ${theme.getTypography('mobile', 'body', 'body3')}
      font-weight: ${theme.typography.mobile.body.body4.fontWeight};
      text-align: start;

      a {
        ${theme.getTypography('mobile', 'body', 'body3')}

        font-weight: ${theme.typography.mobile.body.body4.fontWeight};
      }
    `};
  `}
`

export const List = styled.ul`
  ${({ theme }) => css`
    list-style-image: url('/images/list-hexagon-dark.webp');
    padding-left: ${theme.newSpaces.sm}px;

    ${theme.below.tabletS`
      list-style-image: none;
    `}
  `}
`

export const ListItem = styled.li`
  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'body', 'body2')}

    color: ${theme.newColors.darkGray};
    margin: ${theme.newSpaces.sm}px 0;
    padding-left: ${theme.newSpaces.xs2}px;

    ${theme.below.mobileL`
      ${theme.getTypography('mobile', 'body', 'body3')};

      font-weight: ${theme.typography.mobile.body.body4.fontWeight};

      padding-left: 0;
      margin: ${theme.newSpaces.xs2}px 0;
    `}
  `}
`

export const Article = styled(Box)`
  ${({ theme }) => css`
    margin-top: ${theme.newSpaces.xs}px;
  `}
`
